/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { Heading1, Paragraph } from '@motili/ui';
import { ReactElement } from 'react';
import { styled } from 'styled-components';
import CenteredContainer from '../../../components/layout/CenteredContainer';
import StyledButton from '../../../components/styled/StyledButton';
import onboardingVideo from '../../../assets/Contractor-Onboarding-Video.mp4';
import ButtonContainer from '../../../components/layout/ButtonContainer';

export default function RegistrationComplete(): ReactElement {
    return (
        <CenteredContainer>
            <Heading1>Registration Complete!</Heading1>
            <Paragraph>
                Thanks for joining Motili. Our team is reviewing your account.
                You'll hear from us shortly with next steps.
            </Paragraph>
            <Paragraph>
                In the meantime, get a quick overview below of how to invite
                team members, configure your account, and begin using the
                platform.
            </Paragraph>
            <video width={600} height={280} controls>
                <source src={onboardingVideo} type='video/mp4' />
                <track kind='captions' />
                Your browser does not support the video tag.
            </video>
            <ButtonContainer>
                <StyledLink href='https://www.motili.com/'>
                    <StyledButton variant='primary' onClick={() => {}}>
                        Visit Motili Website
                    </StyledButton>
                </StyledLink>
            </ButtonContainer>
        </CenteredContainer>
    );
}

const StyledLink = styled.a`
    & > button {
        min-width: 100%;
    }
`;
